import { Input } from 'antd';
import React from 'react';
import './styles/InputComponent.less';

const InputComponent = (props) => {
  const { name = '', className = '', ...rest } = props;

  return (
    <Input
      className={`input-component-cpq fill-width ${className}`}
      type="text"
      allowClear
      autoComplete="off"
      placeholder={`Enter ${name}`}
      {...rest}
    />
  );
};

export default InputComponent;
